import HomeHeader from '../../components/HomeHeader'
import Sidebar from '../../components/SideBar'
import ExpirationInfoContent from './components/ExpirationInfoContent'
import { useGetOrderFulfilled } from './hooks/use-get-order-fulfilled'

const ExpirationInfo: React.FC = () => {
  const swrOrdersInfo = useGetOrderFulfilled()
  const isLoading = swrOrdersInfo.isLoading
  const userOrdersInfo = isLoading ? null : swrOrdersInfo.data

  return (
    <>
      <Sidebar />
      <HomeHeader />
      <ExpirationInfoContent userOrders={userOrdersInfo} isLoading={isLoading} />
    </>
  )
}

export default ExpirationInfo
